// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash-es';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { ConditionsState } from '../_reducers/condition.reducers';
import { Condition } from '../_models/condition.model';

export const selectConditionsState = createFeatureSelector<ConditionsState>('conditions');

export const selectConditionById = (contactRelationshipId: number) =>
  createSelector(selectConditionsState, (conditionsState) => {
    return conditionsState.entities[contactRelationshipId];
  });

export const selectConditionsPageLoading = createSelector(
  selectConditionsState,
  (conditionsState) => conditionsState.loading,
);

export const selectCurrentEntityIdInStoreForCondition = createSelector(
  selectConditionsState,
  (conditionsState) => conditionsState.entityId,
);

export const selectConditionsWaitingMessage = createSelector(
  selectConditionsState,
  (conditionsState) => conditionsState.showInitWaitingMessage,
);

export const selectConditionsActionLoading = createSelector(
  selectConditionsState,
  (conditionsState) => conditionsState.actionsloading,
);

export const selectConditionErrorState = createSelector(
  selectConditionsState,
  (conditionState) => conditionState.error,
);

export const selectConditionsInStore = createSelector(selectConditionsState, (conditionsState) => {
  const items: Condition[] = [];
  each(conditionsState.entities, (element) => {
    items.push(element);
  });
  return new QueryResultsModel(items, conditionsState.totalCount);
});
